/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-12-23 09:17:22
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-06-19 14:39:46
 * @FilePath: /wemeet-web-activity/src/pages/questions/components/questionList/index.tsx
 * @Description: 问题列表
 */
import React, { Fragment, memo, useCallback } from 'react';
import { AnswerType, IsRequired, QuestionType } from "../../type/index";
import Radio from "../radio/index";
import Checkbox from "../checkbox/index";
import Phone from "../phone/index";
import { Input, Form } from '@tencent/tea-component';
import update from 'immutability-helper';
// import { AppContext } from '@utils/browser/app-context';
import FormInput from "../input/index";
// import { UserData } from '@utils/login-util';
import { Validator } from "../../../PayEnd/component/phoneInput/validator";
const QuestionList = ({
  isMobile,
  formList,
  setFormList,
  userData,
  http
}) => {
  // 修改除手机号之外的其他输入项的值
  const changeFormItemValue = (val, index, checkPhone, code) => {
    const item = formList[index];
    let isValid = val;
    if (item.answer_type === AnswerType.CHECKBOX) {
      isValid = (val?.length || 0) > 1;
    }
    const nFormList = update(formList, {
      [index]: {
        answer: {
          $set: val
        },
        error: {
          $set: item.is_required === IsRequired.REQUIRED && !isValid ? '必填问题不能为空' : ''
        },
        checkPhone: {
          $set: checkPhone
        },
        verification_code: {
          $set: code
        }
      }
    });
    setFormList(nFormList);
  };

  // 不管是否自己手机号都要验证码吧
  const changePhone = useCallback((phoneObj, index, defaultCheck) => {
    const oPhone = `${phoneObj.area};${phoneObj.phone || ''}`;
    // console.log('======1=====', defaultCheck === 0 || phoneObj.phone === userData.phone);
    // 变成自己的手机号时候，就不需要验证码了
    changeFormItemValue(oPhone, index, !(defaultCheck === 0 || phoneObj.phone === userData.phone), phoneObj.sms);
  }, [formList, userData]);

  // 输入类如果必填需要校验是否为空
  const onBlurItem = index => {
    const item = formList[index];
    const {
      answer,
      is_required: isRequired
    } = item;
    let nFormList = formList;
    let msg = '';
    if (isRequired === IsRequired.REQUIRED && !answer) {
      msg = '必填问题不能为空';
    } else if (item.question_type === QuestionType.EMAIL && answer && !Validator.isEmail(answer)) {
      // 邮箱验证
      msg = '请输入正确的邮箱';
    }
    if (msg) {
      nFormList = update(nFormList, {
        [index]: {
          error: {
            $set: msg
          }
        }
      });
      // 有错误才更新，没错误就不需要更新
      setFormList(nFormList);
    }
  };
  return /*#__PURE__*/React.createElement(Form, {
    layout: "vertical",
    className: "event-question-form"
  }, formList.map((item, index) => {
    if (item.question_type === QuestionType.CUSTOMIZE && (item.answer_type === AnswerType.RADIO || item.answer_type === AnswerType.CHECKBOX) && item.question_option_list?.length === 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Fragment, {
      key: `question-${index}`
    }, item.question_type === QuestionType.PHONE ? /*#__PURE__*/React.createElement(Phone, {
      isMobile: isMobile,
      onChange: val => changePhone(val, index, item.open_check),
      value: item.answer,
      required: item.is_required === IsRequired.REQUIRED,
      userPhone: userData.phone,
      list: formList,
      openCheck: item.open_check,
      http: http
    }) : /*#__PURE__*/React.createElement(Form.Item, {
      label: /*#__PURE__*/React.createElement(React.Fragment, null, item.question_title, /*#__PURE__*/React.createElement("span", {
        className: "label-span"
      }, item.answer_type === AnswerType.RADIO ? '[单选]' : '', item.answer_type === AnswerType.CHECKBOX ? '[多选]' : '')),
      required: item.is_required === IsRequired.REQUIRED,
      message: item.error || '',
      status: item.error ? 'error' : undefined,
      showStatusIcon: false,
      className: "event-question-item-controller"
    }, item.answer_type === AnswerType.RADIO && /*#__PURE__*/React.createElement(Radio, {
      onChange: val => {
        changeFormItemValue(val, index);
      },
      value: item.answer,
      options: item.question_option_list
    }), item.answer_type === AnswerType.CHECKBOX && /*#__PURE__*/React.createElement(Checkbox, {
      onChange: val => {
        changeFormItemValue(val, index);
      },
      value: item.answer,
      options: item.question_option_list
    }), item.answer_type === AnswerType.INPUT && /*#__PURE__*/React.createElement(FormInput, {
      item: item,
      userData: userData,
      onChange: val => {
        changeFormItemValue(val, index);
      },
      onBlur: () => {
        onBlurItem(index);
      },
      list: formList
    }), item.answer_type === AnswerType.TEXTAREA && /*#__PURE__*/React.createElement(Input.TextArea, {
      size: "full",
      value: item.answer,
      onChange: val => {
        changeFormItemValue(val, index);
      },
      placeholder: "\u8BF7\u8F93\u5165",
      onBlur: () => {
        onBlurItem(index);
      },
      maxLength: 200,
      showCount: true
    })));
  }));
};
export default /*#__PURE__*/memo(QuestionList);